import React from 'react'
import { links } from '@/constants/avenue-links'
import { CopyOutlined } from '@ant-design/icons'

const PC = (props) => {
  const { item, toCopy } = props

  function toAvenue (item) {
    window.open(links.pc(item.encryptActivityId))
  }

  return (
    <div className='PC-content'>
      <div className='link-wrap'>
        <div className='link' onClick={() => toAvenue(item)}>{links.pc(item.encryptActivityId)}</div>
        <div className='copy' onClick={(e) => toCopy(e, links.pc(item.encryptActivityId))}><CopyOutlined className='icon' />复制链接</div>
      </div>
    </div>
  )
}

export default PC
